import React from 'react';

function DataTable({ data }) {
  // Handle empty data
  if (!data || Object.keys(data).length === 0) {
    return <div className="text-sm text-gray-500">No data available</div>;
  }

  // If data is an array of objects, extract headers from the first object
  let headers = [];
  let rows = [];

  if (Array.isArray(data)) {
    // Handle array of objects
    if (data.length > 0 && typeof data[0] === 'object') {
      headers = Object.keys(data[0]);
      rows = data;
    } 
    // Handle array of arrays (first row might be headers)
    else if (data.length > 0 && Array.isArray(data[0])) {
      headers = data[0];
      rows = data.slice(1).map(row => {
        return headers.reduce((obj, header, index) => {
          obj[header] = row[index];
          return obj;
        }, {});
      });
    }
  } 
  // Handle object with arrays as values (columns)
  else if (typeof data === 'object') {
    headers = Object.keys(data);
    
    // Determine the number of rows
    const maxLength = Math.max(...headers.map(header => 
      Array.isArray(data[header]) ? data[header].length : 0
    ));
    
    // Create a row for each index
    for (let i = 0; i < maxLength; i++) {
      const row = {};
      headers.forEach(header => {
        row[header] = data[header] && data[header][i] !== undefined 
          ? data[header][i] 
          : null;
      });
      rows.push(row);
    }
  }

  // Limit number of rows to display to prevent performance issues
  const MAX_ROWS = 100;
  const displayRows = rows.slice(0, MAX_ROWS);
  const hasMoreRows = rows.length > MAX_ROWS;

  return (
    <div className="overflow-x-auto mt-3 bg-white dark:bg-slate-700 p-2 rounded-md">
      <table className="min-w-full divide-y divide-gray-200 dark:divide-slate-600">
        <thead className="bg-gray-50 dark:bg-slate-800">
          <tr>
            {headers.map((header, index) => (
              <th
                key={index}
                scope="col"
                className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-slate-400 uppercase tracking-wider"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white dark:bg-slate-700 divide-y divide-gray-200 dark:divide-slate-600">
          {displayRows.map((row, rowIndex) => (
            <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-white dark:bg-slate-700' : 'bg-gray-50 dark:bg-slate-800/30'}>
              {headers.map((header, colIndex) => (
                <td
                  key={`${rowIndex}-${colIndex}`}
                  className="px-3 py-2 whitespace-nowrap text-xs text-gray-800 dark:text-slate-300"
                >
                  {row[header] !== null && row[header] !== undefined 
                    ? String(row[header]) 
                    : <span className="text-gray-400 dark:text-slate-500">null</span>}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {hasMoreRows && (
        <div className="text-xs text-gray-500 dark:text-slate-400 py-2 px-3 text-center">
          Showing {MAX_ROWS} of {rows.length} rows
        </div>
      )}
    </div>
  );
}

export default DataTable;